// src/components/common/ProtectedRoute/ProtectedRoute.tsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../../../features/auth/services/authService';

const ProtectedRoute: React.FC = () => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/auth" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
